import { useTranslation } from 'react-i18next';
import { categories, mainSiteUrl } from '@/mocks/categories';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
          {t('category.title')}
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600">{t('category.subtitle')}</p>
      </div>

      <div className="mt-8 flex justify-center">
        <CategoryDropdown />
      </div>

      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.key}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:border-primary-300 cursor-pointer"
            data-product-shop
          >
            <div className="relative h-24 md:h-28 overflow-hidden">
              <img
                src={cat.image}
                alt={`${t(`cat.${cat.key}`)} AllChinaBuy Spreadsheet`}
                title={`${t(`cat.${cat.key}`)} AllChinaBuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center gap-2 p-3">
              <span className="flex w-7 h-7 md:w-8 md:h-8 items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
                <i className={`${cat.icon} text-base`}></i>
              </span>
              <span className="text-sm md:text-base font-medium text-foreground-800 leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
                {t(`cat.${cat.key}`)}
              </span>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-8 flex flex-col items-center gap-3">
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {t('category.viewAll')}
          <span className="flex w-4 h-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </a>
        <p className="text-xs text-foreground-500">{t('category.note')}</p>
      </div>
    </section>
  );
}